/**
 * Country Card (used on homepage country groups and country post prev/next)
 */

import React from "react"
import parse from "html-react-parser"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { FaExternalLinkAlt } from "react-icons/fa"

const NewsCard = ({ props, rel, description, includeNodeType }) => {
  const { title } = props
  const postOptions = props?.postOptions
  const uri =
    postOptions?.linkDirectlyToExternalLink && postOptions?.externalLink?.url
      ? postOptions.externalLink.url
      : props?.uri
  function filterCategories(category) {
    return category.name !== "Uncategorized" || category.name !== "Featured"
  }
  const categories = props?.categories?.nodes.filter(filterCategories)
  const categoriesLength = categories?.length
  const image = {
    src: props.featuredImage?.node?.localFile
      ? getImage(props.featuredImage?.node?.localFile)
      : null,
    alt: props.featuredImage?.node?.altText || ``,
  }
  let date = props?.date ? new Date(props.date) : null
  let options = { day: "2-digit", month: "long", year: "numeric" }
  let dateFormatted = date
    ? new Intl.DateTimeFormat("en-GB", options).format(date)
    : null
  let excerpt = props?.excerpt
  excerpt =
    excerpt?.split(" ")?.length > 16
      ? excerpt?.split(" ")?.slice(0, 16)?.join(" ") + "..."
      : excerpt
  return (
    <article data-sal={description ? "slide-up" : ""}>
      <div className="news-card rounded bg-gray-200 print:max-w-md print:bg-transparent print:border print:border-gray-300 print:shadow-none print:my-4 overflow-hidden transform shadow hover:shadow-lg transition hover:scale-105 block">
        <a
          href={uri}
          target={postOptions?.linkDirectlyToExternalLink ? "_blank" : "_self"}
          className="link-plain"
          itemProp="url"
          rel={rel || "noreferrer"}
        >
          <div className="w-full relative">
            {image?.src ? (
              <div
                className={`w-full ${
                  description ? "h-44 sm:h-52 xl:h-60" : "h-40"
                }`}
              >
                <GatsbyImage
                  image={image.src}
                  className="w-full h-full"
                  objectFit="cover"
                  alt={image.alt}
                />
                {includeNodeType ? (
                  <span className="absolute rounded bg-blue-600 text-white  top-4 right-4 px-2 py-1">
                    News
                  </span>
                ) : null}
              </div>
            ) : null}
            <div className="relative h-full flex items-end">
              <div className="inline-block m-6">
                {description && (
                  <div className="parsed-content leading-snug font-medium mb-2">
                    {parse(description)}
                  </div>
                )}
                <div className="">
                  <h3 className="font-semibold text-base leading-tight mb-2">
                    {parse(title)}
                  </h3>
                  <div className="text-sm uppercase text-gray-900 text-opacity-70 leading-tight mb-1">
                    {postOptions?.externalLink?.title ? (
                      <span className="inline-block font-medium">
                        {parse(postOptions.externalLink.title)}
                      </span>
                    ) : null}
                    {postOptions?.externalLink?.title && dateFormatted ? (
                      <span> | </span>
                    ) : null}
                    {dateFormatted && (
                      <span className="inline-block mb-1">{dateFormatted}</span>
                    )}
                  </div>
                </div>
                {excerpt && (
                  <div className="parsed-content lg:leading-snug mb-1.5   lg:text-base">
                    {parse(excerpt)}
                  </div>
                )}
                <div className="flex items-end">
                  {categories ? (
                    <ul className="flex-grow leading-tight">
                      {categories
                        ?.slice(0, 4)
                        .map((category, categoryIndex) => {
                          return (
                            <li className="text-sm uppercase text-gray-900 text-opacity-70 inline">
                              {category.name ? parse(category.name) : null}
                              {categoryIndex < categoriesLength - 1 ||
                              categoryIndex < 3 ? (
                                <span>, </span>
                              ) : (
                                ""
                              )}
                              {categoryIndex === 3 && categoriesLength > 4 ? (
                                <span aria-label="Categories continued">
                                  [...]
                                </span>
                              ) : null}
                            </li>
                          )
                        })}
                    </ul>
                  ) : null}
                  {postOptions?.linkDirectlyToExternalLink ? (
                    <div className="flex-shrink-0">
                      <FaExternalLinkAlt className="text-xl" />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </article>
  )
}

NewsCard.defaultProps = {
  rel: ``,
  description: ``,
}

export default NewsCard
